import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/icons/Logo.svg?react";
import { ReactComponent as CheckLogo } from "../../assets/icons/check-logo.svg?react";
import { ReactComponent as FolderIcon } from "../../assets/icons/folder.svg?react";
import { ReactComponent as MessageIcon } from "../../assets/icons/message.svg?react";
import { ReactComponent as BulletinIcon } from "../../assets/icons/bulletin.svg?react";
import { ReactComponent as SurveyIcon } from "../../assets/icons/survey.svg?react";
import { ReactComponent as WaitlistIcon } from "../../assets/icons/waitlist.svg?react";
import { ReactComponent as FeedbackIcon } from "../../assets/icons/feedback.svg?react";
import { ReactComponent as EmailIcon } from "../../assets/icons/email.svg?react";
import { ReactComponent as PersonIcon } from "../../assets/icons/person.svg?react";
import { ReactComponent as More } from "../../assets/icons/more.svg?react";
import { ReactComponent as UsersIcon } from "../../assets/icons/users.svg?react";
import { ReactComponent as ReferralIcon } from "../../assets/icons/referral.svg?react";
import { ReactComponent as SyncIcon } from "../../assets/icons/sync.svg?react";
import { ReactComponent as FileIcon } from "../../assets/icons/file.svg?react";
import { ReactComponent as ListTicksIcon } from "../../assets/icons/list-ticks.svg?react";
import { ReactComponent as DashboardIcon } from "../../assets/icons/dashboard.svg?react";
import { ReactComponent as CloseIcon } from "../../assets/icons/x.svg?react";
import { ReactComponent as LeftCollapseIcon } from "../../assets/icons/left-collapse.svg?react";
import { ReactComponent as RightCollapseIcon } from "../../assets/icons/right-collapse.svg?react";
import { ReactComponent as BlogIcon } from "../../assets/icons/blog.svg?react"
import { ReactComponent as ToolsIcon } from "../../assets/icons/tools.svg?react"
import { useEffect, useState } from "react";
import { ReactComponent as ChevronDownIcon } from "../../assets/icons/chevron-down.svg?react";

const HaloSparklesIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
  </svg>
);

const TreatmentPlanAuditorIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);
import { AnimatePresence } from "framer-motion";
import { UserButton } from "../UserButton/UserButton";
import { getUser } from "../../services/utils";
import { Dropdown } from "../Dropdown";
import { LogoutConfirm } from "./LogoutConfirm";
import { useUser } from "../../pages/auth/context/user-context";
import { SettingsModal } from "./SettingsModal";
import { CacheClearingModal } from "./CacheClearingModal";
import { useAdminUsers } from "../../pages/manageAdmin/context/AdminUsersContext";
import { AdminPermission } from "../../pages/manageAdmin/AdminUserList.types";
import { ChangePassword } from "../../pages/provider/profile/ChangePassword";
import useWindowDimensions from "../../services/useWindowDimensions";
import { usePaymentsTestingAccess } from "../../pages/payments/PaymentsTestingGate";

export function MenuItem({
  href,
  active,
  title,
  Icon,
  invertIconColor = false,
  extra,
  collapseMenu = false,
}: {
  href: string;
  active?: boolean;
  title: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  invertIconColor?: boolean;
  extra?: React.ReactNode;
  collapseMenu?: boolean;
}) {

  if (collapseMenu) {
    return (
      <Link
        to={href}
        className={`p-4 hover:bg-secondary ${active ? "!bg-primary" : ""
          } w-full rounded-lg justify-start items-center flex`}
      >
        {extra ? extra :
          <Icon
            className={`w-6 h-6 relative ${active ?
              (invertIconColor) ? "[&_path]:fill-white" : "[&_path]:stroke-white"
              : ""}`}
          />}
      </Link>
    )
  }


  return (
    <Link
      to={href}
      className={`p-4 hover:bg-secondary ${active ? "!bg-primary" : ""
        } w-full rounded-lg justify-start items-center gap-2.5 flex`}
    >
      <Icon
        className={`w-6 h-6 relative ${active ?
          (invertIconColor) ? "[&_path]:fill-white" : "[&_path]:stroke-white"
          : ""}`}
      />
      <div className={`${active ? "text-white" : ""} text-lg font-normal`}>
        {title}
      </div>
      {extra}
    </Link>
  );
}

function PaymentsMenuGroup({
  pathname,
  collapseMenu,
  canReadPayments,
  canAccessTermsAdvances,
}: {
  pathname: string;
  collapseMenu: boolean;
  canReadPayments: boolean;
  canAccessTermsAdvances: boolean;
}) {
  const active = pathname.startsWith('/payments') || pathname === '/mercury-payments';
  const [open, setOpen] = useState(active);

  useEffect(() => {
    if (active) setOpen(true);
  }, [active]);

  if (collapseMenu) {
    return (
      <Link
        to={canReadPayments ? '/payments/overview' : '/payments/terms-and-advances'}
        className={`flex w-full items-center justify-start rounded-lg p-4 hover:bg-secondary ${
          active ? 'bg-secondary' : ''
        }`}
        aria-label="Payments"
        title="Payments"
      >
        <FileIcon className="relative h-6 w-6" />
      </Link>
    );
  }

  return (
    <div className="w-full">
      <button
        type="button"
        className={`flex w-full items-center rounded-lg p-4 hover:bg-secondary ${
          active ? 'bg-secondary' : ''
        } gap-2.5`}
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        aria-label="Toggle Payments navigation"
      >
        <FileIcon className="relative h-6 w-6" />
        <span className="text-lg font-normal">Payments</span>
        <ChevronDownIcon
          className={`ml-auto h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && (
        <div className="ml-8 mt-1 flex flex-col gap-1 border-l border-slate-200 pl-3">
          {[
            ...(canReadPayments
              ? [
                  { href: '/payments/overview', label: 'Overview' },
                  { href: '/payments/weekly', label: 'Weekly Payments' },
                ]
              : []),
            ...(canAccessTermsAdvances
              ? [
                  {
                    href: '/payments/terms-and-advances',
                    label: 'Practice Terms & Advances',
                  },
                ]
              : []),
          ].map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`rounded-md px-3 py-2 text-sm ${
                pathname === item.href
                  ? 'bg-secondary font-semibold text-primary'
                  : 'text-slate-600 hover:bg-secondary'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

/** Build responsive navigation from the current operator's permissions. */
export function MenuItemList({ count, collapseMenu, extraOpen, setExtraOpen }) {
  const pathname = window.location.pathname;
  const { myPermissions } = useAdminUsers()
  const { hasAccess: hasPaymentCloseAccess } = usePaymentsTestingAccess();
  const { hasAccess: hasTermsAdvancesAccess } = usePaymentsTestingAccess([
    AdminPermission.READ_PAYMENT_CLOSE,
    AdminPermission.MANAGE_PAYMENT_ADVANCE_REQUESTS,
    AdminPermission.MANAGE_PAYMENT_TERMS,
    AdminPermission.MANAGE_PAYMENT_ADVANCES,
    AdminPermission.ADJUST_PAYMENT_ADVANCE_BALANCE,
  ]);
  const { height, width } = useWindowDimensions();

  const menuItemList = [<MenuItem
    href="/dashboard"
    title="Dashboard"
    Icon={DashboardIcon}
    active={pathname === "/dashboard"}
    key="dashboard"
    collapseMenu={collapseMenu}
  />]

  if (myPermissions?.includes(AdminPermission.USE_HALO_AI)) {
    menuItemList.push(<MenuItem
      href="/halo"
      title="Halo"
      Icon={HaloSparklesIcon}
      active={pathname === "/halo"}
      key="halo"
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions?.some(p => [
    AdminPermission.READ_CHAT_CLIENT,
    AdminPermission.READ_CHAT_GENERAL_ADMIN,
    AdminPermission.READ_CHAT_INS_OPS_ADMIN,
    AdminPermission.READ_CHAT_RBT_ADMIN,
    AdminPermission.READ_CHAT_RBT_ADMIN
  ].includes(p))) {
    menuItemList.push(<MenuItem
      href="/messages"
      title="Messages"
      key="messages"
      Icon={MessageIcon}
      active={pathname === "/messages"}
      extra={
        count ? (
          <div
            className={`w-7 h-5 ${pathname === "/messages"
              ? "text-primary bg-white"
              : "text-white bg-primary"
              } rounded-3xl flex-col justify-start items-center gap-2.5 flex`}
          >
            <div className="text-sm font-normal">{count}</div>
          </div>
        ) : null
      }
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_CLIENTS)) {
    menuItemList.push(<MenuItem
      href="/clients"
      key="clients"
      title="Manage Clients"
      Icon={UsersIcon}
      active={pathname === "/clients"}
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_REFERRALS)) {
    menuItemList.push(<MenuItem
      href="/client-referrals"
      title="Manage Referrals"
      key="referrals"
      Icon={ReferralIcon}
      active={pathname === "/client-referrals"}
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_PROVIDERS)) {
    menuItemList.push(<MenuItem
      href="/providers"
      title="Manage Providers"
      key="providers"
      Icon={PersonIcon}
      active={pathname === "/providers"}
      collapseMenu={collapseMenu}
    />)
  }
  if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_AUTH_REQUEST)) {
    menuItemList.push(<MenuItem
      href="/auth-requests"
      key="auth-requests"
      title="Auth Requests"
      Icon={ListTicksIcon}
      active={pathname === "/auth-requests"}
      collapseMenu={collapseMenu}
    />)
  }
  if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_BLOG)) {
    menuItemList.push(<MenuItem
      href="/blogs"
      key="blogs"
      title="Blog"
      Icon={BlogIcon}
      active={pathname === "/blogs"}
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions?.includes(AdminPermission.READ_ALOHA_PROVISIONING)) {
    menuItemList.push(<MenuItem href="/aloha-provisioning" key="aloha-provisioning" title="Aloha Setup" Icon={ListTicksIcon} active={pathname.startsWith("/aloha-provisioning")} collapseMenu={collapseMenu} />)
  }

  if (myPermissions?.includes(AdminPermission.READ_CONTENT_ENGINE)) {
    menuItemList.push(<MenuItem
      href="/content-engine"
      key="content-engine"
      title="Content Review"
      Icon={ListTicksIcon}
      active={pathname.startsWith("/content-engine")}
      collapseMenu={collapseMenu}
    />)
  }

  const hasCandidSyncRead = myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_CANDID_SYNC);
  const hasCandidSyncWrite = myPermissions?.includes(AdminPermission.WRITE_PAGE_MANAGE_CANDID_SYNC);

  if (hasCandidSyncRead) {
    menuItemList.push(<MenuItem
      href="/candid-sync"
      key="candid-sync"
      title="Candid Sync"
      Icon={SyncIcon}
      active={pathname === "/candid-sync"}
      collapseMenu={collapseMenu}
    />)
  }

  if (hasCandidSyncWrite) {
    menuItemList.push(<MenuItem
      href="/claims"
      key="claims"
      title="Claims"
      Icon={FileIcon}
      active={pathname === "/claims"}
      collapseMenu={collapseMenu}
    />)
  }

  if (hasPaymentCloseAccess || hasTermsAdvancesAccess) {
    menuItemList.push(
      <PaymentsMenuGroup
        key="payments"
        pathname={pathname}
        collapseMenu={collapseMenu}
        canReadPayments={hasPaymentCloseAccess}
        canAccessTermsAdvances={hasTermsAdvancesAccess}
      />
    )
  }

  if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_BULLETIN)) {
    menuItemList.push(<MenuItem
      href="/bulletin"
      key="bulletin"
      title="Manage Bulletin"
      Icon={BulletinIcon}
      invertIconColor={true}
      active={pathname === "/bulletin"}
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_FORMS)) {
    menuItemList.push(<MenuItem
      href="/surveys"
      key="surveys"
      title="Manage Surveys"
      Icon={SurveyIcon}
      // invertIconColor={true}
      active={pathname === "/surveys"}
      collapseMenu={collapseMenu}
    />)
  }
  if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_FEEDBACK)) {
    menuItemList.push(<MenuItem
      href="/feedback"
      key="feedback"
      title="Manage Feedback"
      Icon={FeedbackIcon}
      // invertIconColor={true}
      active={pathname === "/feedback"}
      collapseMenu={collapseMenu}
    />)
  }
  if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_FEEDBACK)) {
    menuItemList.push(<MenuItem
      href="/contact-submissions"
      key="contact-submissions"
      title="Contact Submissions"
      Icon={EmailIcon}
      active={pathname === "/contact-submissions"}
      collapseMenu={collapseMenu}
    />)
  }
  if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_WAITLIST)) {
    menuItemList.push(<MenuItem
      href="/waitlist"
      key="waitlist"
      title="Manage Waitlist"
      Icon={WaitlistIcon}
      invertIconColor={true}
      active={pathname === "/waitlist"}
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_LIBRARY)) {
    menuItemList.push(<MenuItem
      href="/library"
      key="library"
      title="Manage Library"
      Icon={FolderIcon}
      active={pathname === "/library"}
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions.includes(AdminPermission.READ_PAGE_MANAGE_FINANCIAL_TOOLKIT)) {
    menuItemList.push(<MenuItem
      href="/financial-toolkit"
      key="financial-toolkit"
      title="Financial Toolkit"
      Icon={ToolsIcon}
      active={pathname === "/financial-toolkit"}
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions.includes(AdminPermission.MANAGE_NOTIFICATIONS)) {
    menuItemList.push(<MenuItem
      href="/manage-notifications"
      key="manage-notifications"
      title="Manage Notifications"
      Icon={BulletinIcon}
      active={pathname === "/manage-notifications"}
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions?.includes(AdminPermission.USE_TREATMENT_PLAN_AUDITOR)) {
    menuItemList.push(<MenuItem
      href="/treatment-plan-auditor"
      key="treatment-plan-auditor"
      title="Treatment Plan Auditor"
      Icon={TreatmentPlanAuditorIcon}
      active={pathname === "/treatment-plan-auditor"}
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions?.includes(AdminPermission.READ_CREDENTIALING)) {
    menuItemList.push(<MenuItem
      href="/credentialing"
      key="credentialing"
      title="Credentialing"
      Icon={ListTicksIcon}
      active={pathname.startsWith("/credentialing")}
      collapseMenu={collapseMenu}
    />)
  }

  if (myPermissions?.includes(AdminPermission.USE_TREATMENT_AUTHORIZATION_REVIEWER)) {
    menuItemList.push(<MenuItem
      href="/treatment-authorizations"
      key="treatment-authorizations"
      title="Treatment Authorizations"
      Icon={ListTicksIcon}
      active={pathname.startsWith("/treatment-authorizations")}
      collapseMenu={collapseMenu}
    />)
  }



  if (collapseMenu) {
    return <div className="w-full flex-col justify-start items-start flex">{menuItemList}</div>;
  }

  let maxNum = ((height - 265) / 65) < 10 ? Math.floor(((height - 265) / 65)) : 9

  if (menuItemList.length <= (maxNum + 1) || maxNum === 0) {
    return (
      <div className="w-full flex-col justify-start items-start gap-2.5 flex">
        {menuItemList}
      </div>
    );
  }

  const overflowItems = menuItemList.splice(maxNum)

  return (
    <div className="w-full flex-col justify-start items-start gap-2.5 flex">
      {!extraOpen && menuItemList}

      <div
        className={`p-4 hover:bg-secondary cursor-pointer border w-full rounded-lg justify-start items-center gap-2.5 flex`}
        onClick={() => setExtraOpen(!extraOpen)}
      >
        {extraOpen ? <div className="w-6 h-6" /> : <More
          className={`w-6 h-6 relative ${extraOpen ? "[&_path]:stroke-white" : ""}`}
        />}
        <div className={`text-lg font-normal`}>
          {extraOpen ? "Collapse Other" : "Manage Other"}
        </div>
        {extraOpen && <div style={{ transform: 'translateX(20px)' }}><CloseIcon className={`w-6 h-6 relative`} /> </div>}
      </div>
      {extraOpen && overflowItems}
    </div>
  );


}

export function Menu() {
  const user = getUser();
  const { myPermissions, initialPermissionsLoaded } = useAdminUsers()
  const { userInfo = {}, totalUnreadConvCount } = useUser() as any;
  const [openDropdown, setOpenDropdown] = useState(false);
  const [logoutConfirm, setLogoutConfirm] = useState(false);
  const [settingsModal, setSettingsModal] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showCacheClearing, setShowCacheClearing] = useState(false);
  const [collapseMenu, setCollapseMenu] = useState(false);
  const [extraOpen, setExtraOpen] = useState(false);

  const handleLogoutConfirm = () => {
    setLogoutConfirm(false);
    localStorage.clear();
    window.location.href = "/login";
  };

  const handleLogout = () => {
    setOpenDropdown(false);
    setLogoutConfirm(true);
  };

  const handleSettings = () => {
    setOpenDropdown(false);
    setSettingsModal(true);
  };

  const handleSettingsClose = () => {
    setSettingsModal(false);
  };

  if (!initialPermissionsLoaded) {
    return null
  }

  return (
    <>
      <div className={`${collapseMenu ? 'w-[80px]' : 'w-[264px]'} flex-col bg-white justify-start items-start flex`}>
        <div className="px-7 py-6 w-full border-b border-gray-200 flex-col justify-center items-start gap-2.5 flex">
          {collapseMenu ? <RightCollapseIcon className="w-7 h-7 cursor-pointer inline-block [&_path]:stroke-primary" onClick={() => setCollapseMenu(false)} /> : <div className="inline-block">
            <Logo className="w-[143px] h-7 inline-block" />
            <LeftCollapseIcon className="ml-9 w-7 h-7 cursor-pointer inline-block [&_path]:stroke-primary" onClick={() => { setCollapseMenu(true); setExtraOpen(false) }} />

          </div>}
        </div>
        <div className="self-stretch grow shrink basis-0 p-3 bg-white border-b border-black border-opacity-10 backdrop-blur-[27px] flex-col justify-start items-start gap-96 flex">
          <div className="self-stretch grow shrink basis-0 flex-col justify-between items-center flex">
            <div className="w-full flex-col justify-center items-start gap-1 flex">
              <MenuItemList count={totalUnreadConvCount} collapseMenu={collapseMenu} extraOpen={extraOpen} setExtraOpen={setExtraOpen} />
            </div>
            <div className="block relative w-full">
              <UserButton
                className="w-full [&>div]:!mx-0 !mb-0"
                variant="sideMenu"
                user={{ ...user, ...userInfo }}
                onClick={() => { setCollapseMenu(false); setOpenDropdown(true) }}
                collapseMenu={collapseMenu}
              />
              <Dropdown
                padding="15px"
                className="w-full !top-[-110px] !justify-start !items-start flex"
                isOpen={openDropdown}
                setIsOpen={() => setOpenDropdown(false)}
              >

                <button
                  className="h-8 text-left text-base w-full"
                  onClick={() => setShowChangePassword(true)}
                >
                  Change Password
                </button>

                {myPermissions?.includes(AdminPermission.MANAGE_ADMIN) &&
                  <Link to={"/manage-admin"}>
                    <button
                      className="text-black hover:text-black/80 h-8 text-left text-base w-full"
                      onClick={() => setOpenDropdown(false)}
                    >
                      Manage Admin
                    </button>
                  </Link>
                }

                {myPermissions?.includes(AdminPermission.MANAGE_CACHE) &&
                  <button
                    className="text-black hover:text-black/80 h-8 text-left text-base w-full"
                    onClick={() => {
                      setShowCacheClearing(true);
                      setOpenDropdown(false);
                    }}
                  >
                    Clear Cache
                  </button>
                }
                {/* <button
                  className="text-black hover:text-black/80 h-8 text-left text-base w-full mb-2"
                  onClick={handleSettings}
                >
                  Settings
                </button> */}
                <button
                  className="text-[#E3270E] h-8 text-left text-base w-full"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      <AnimatePresence mode="wait" initial={false}>
        {showChangePassword && (
          <ChangePassword onClose={() => setShowChangePassword(false)} user={user} />
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait" initial={false}>
        {showCacheClearing && (
          <CacheClearingModal onClose={() => setShowCacheClearing(false)} />
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait" initial={false}>
        {logoutConfirm && (
          <LogoutConfirm
            onCancel={() => setLogoutConfirm(false)}
            onConfirm={handleLogoutConfirm}
          />
        )}
      </AnimatePresence>
      <AnimatePresence mode="wait" initial={false}>
        {settingsModal && <SettingsModal onClose={handleSettingsClose} />}
      </AnimatePresence>
    </>
  );
}
